module.exports = require("core-js/modules/es.string.includes");